const e = "infoPage_Vylyq", t = "infoPage__text_KJVgX", o = {
  infoPage: e,
  infoPage__text: t
};
export {
  o as default,
  e as infoPage,
  t as infoPage__text
};
//# sourceMappingURL=infoPage.module.scss.js.map
